import React, {useRef, useEffect} from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import { useSelector } from "react-redux";
import { getOptionsSelector } from "../../Slices/optionSlice";
import {durationColor,countColor, machineTimeColors} from "../../Constants"
import { Popover } from "bootstrap";


interface AlarmComboChartProps {
  values?: string
  category:string
  id: string
  data?: any
  clickHandler?: any
  combined?:boolean;
  type:"alarms" | "machineTimes" | "machineTimesPerDay"
  itemNumber:number;
  series: {
    name:string,
    unit:string,
    color:string
    }
}

// const chartColors = [
//   am4core.color("green"),
//   am4core.color("red"),
//   am4core.color("pink"),
//   am4core.color("yellow"),
//   am4core.color("orange"),
//   am4core.color("blue"),
// ];

// function am4themes_myTheme(target:am4core.ColorSet) {
//   if (target instanceof am4core.ColorSet) {
//     target.list = chartColors;
//   }
// }
// am4core.useTheme(am4themes_myTheme(chartColors));

const AlarmComboChartGood = (props: AlarmComboChartProps) =>{
  const options = useSelector(getOptionsSelector);

  const chart = useRef(null);
  am4core.options.autoDispose = true;

  useEffect(() => {
    
    chart.current = am4core.create(props.id, am4charts.XYChart);
    if (props.data.length > 0){
      let arr = [...props.data]
      if(props.itemNumber !== 0){
        arr = arr.splice(0,props.itemNumber);
        
      }
      createChart(arr);
    }
    return function cleanup() {
     if (chart.current) {
         chart.current.dispose();
       }
     };
}, [props.data]);

  const createChart = (data:any) =>{
      chart.current.data = data
      chart.current.cursor = new am4charts.XYCursor();
      chart.current.cursor.behavior = "panX";
      chart.current.mouseWheelBehavior = "zoomX";

      let title = chart.current.titles.create()
      title.text = props.series.name;

      //legends
      chart.current.legend = new am4charts.Legend();
      chart.current.legend.position = "right";
      chart.current.legend.valign = "top";
      chart.current.legend.width = 100;
      chart.current.legend.labels.template.truncate = false;
      chart.current.legend.labels.template.wrap = true;
      chart.current.legend.marginLeft = 0;
      chart.current.legend.marginRight = 0;
      chart.current.legend.marginTop = 0;
      chart.current.legend.fontSize = "11px";
      chart.current.legend.itemContainers.template.paddingTop = 3;
      chart.current.legend.itemContainers.template.paddingBottom = 2;
      //legend styles
      var markerTemplate = chart.current.legend.markers.template;
      markerTemplate.width = 10;
      markerTemplate.height = 10;

      chart.current.exporting.menu = new am4core.ExportMenu();
      chart.current.exporting.menu.align = 'left';
      chart.current.exporting.menu.verticalAlign = 'top';

      //Create axes
      let categoryAxis = chart.current.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = props.category;
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 30;
      //chart.current.cursor.behavior = "panX";
      //chart.current.mouseWheelBehavior = "zoomX";
      categoryAxis.cursorTooltipEnabled = true;
      // categoryAxis.renderer.cellStartLocation = 0.1
      // categoryAxis.renderer.cellEndLocation = 0.9

      let label = categoryAxis.renderer.labels.template;
      label.truncate = true;
      label.maxWidth = 100;
      label.fontSize = 12;
      label.tooltipText = "{category}";
     
      label.rotation = -30;
      label.horizontalCenter = "right";

      var hourAxis = chart.current.yAxes.push(new am4charts.ValueAxis());
      hourAxis.cursorTooltipEnabled = false;
      hourAxis.fontSize = 12;
      hourAxis.layout = "absolute";
      hourAxis.title.rotation = 0;
      hourAxis.title.align = "center"
      hourAxis.title.valign = "top"
      hourAxis.title.dy = -30;

      let countAxis = chart.current.yAxes.push(new am4charts.ValueAxis());
      countAxis.fontSize = 12;
      countAxis.layout = "absolute";
      countAxis.title.rotation = 0;
      countAxis.title.align = "center"
      countAxis.title.valign = "top"
      countAxis.title.dy = -30;
      countAxis.cursorTooltipEnabled = false;
      
      if (options.machineTimesVisibility === true && props.combined || props.type==="machineTimes" ) {
        
        //hourAxis.title.text = props.series.unit;
        //categoryAxis.tooltip.dy = 30;
        createSeries("runningDuration", "Running", false, machineTimeColors.running);
        createSeries("idleAfterRunningDuration","Idle after Running",true, machineTimeColors.idleAdferRunning);
        createSeries("idleAfterFailureDuration","Idle after Failure",true, machineTimeColors.idleAfterFailure);
        createSeries("failureTimeoutDuration", "Failure Timeout", true, machineTimeColors.failureTimeout);
        createSeries("failureDuration", "Failure", true, machineTimeColors.failure);
        createSeries("shiftDuration", "Shift length", true, machineTimeColors.shift);
      }

      if (props.type === "machineTimesPerDay" ) {
        //hourAxis.title.text = props.series.unit;
        //categoryAxis.tooltip.dy = 30;
        title.text = "Total times divided by number of devices divided by days"
        createSeries("runningDurationPerDay", "Running", false, machineTimeColors.running);
        createSeries("idleAfterRunningDurationPerDay","Idle after Running",true, machineTimeColors.idleAdferRunning);
        createSeries("idleAfterFailureDurationPerDay","Idle after Failure",true, machineTimeColors.idleAfterFailure);
        createSeries("failureTimeoutDurationPerDay", "Failure Timeout", true, machineTimeColors.failureTimeout);
        createSeries("failureDurationPerDay", "Failure", true, machineTimeColors.failure);
        createSeries("shiftDurationPerDay", "Shift length", true, machineTimeColors.shift);
      }

      if(props.type === "alarms"){
        createSeries(props.values,props.series.name,false,am4core.color(props.series.color))
      }

      if(options.alarmsVisibility === true && props.combined && props.type==="machineTimes"){
        
        createSeries("duration", "Alarm Duration", false, am4core.color(durationColor))
        
        createSeries("count", "Alarm Count", false, am4core.color(countColor))
      }


      function createSeries(field:string, name:string, stacked:boolean, seriesColor:am4core.Color) {
        if (field === "shiftDuration" || field === "shiftDurationPerDay") {
          var lineSeries = chart.current.series.push(new am4charts.LineSeries());
          lineSeries.name = name;
          lineSeries.dataFields.valueY = field;
          lineSeries.dataFields.categoryX = props.category;

          lineSeries.yAxis = hourAxis;

          lineSeries.tooltipText = "{name}: [bold]{valueY}[/]";
          lineSeries.tooltip.dy = -5;
          lineSeries.tooltip.label.paddingTop = 2;
          lineSeries.tooltip.label.paddingBottom = 2;
          lineSeries.stroke = seriesColor;
          lineSeries.fill = seriesColor;
        } else {
          let series = chart.current.series.push(new am4charts.ColumnSeries());
          series.dataFields.valueY = field;
          series.dataFields.categoryX = props.category;
          series.name = name;
          series.columns.template.fillOpacity = 0.8;
          series.tooltip.dy = -2;
          series.tooltip.label.paddingTop = 2;
          series.tooltip.label.paddingBottom = 2;
          series.tooltip.label.interactionsEnabled = true;

          if (field == "count" || field == "duration") {
            const tooltipString = field.charAt(0).toUpperCase() + field.slice(1)
            series.tooltipText = tooltipString +": [bold]{valueY}[/]";
          } else {
            series.tooltipText = "{name}: [bold]{valueY}[/]";
          }
          series.stacked = stacked;
          series.columns.template.width = am4core.percent(95);


          if (props.values === "count" && field !== "count"){
            series.yAxis = hourAxis;
          }

          if (props.values === "duration"){
            series.yAxis = hourAxis;
            hourAxis.title.text = "Hours"
          }

          if(props.type === "machineTimes" && field === "count"){
            series.yAxis = countAxis;
            countAxis.title.text = "Count"
          }

          series.columns.template.events.on("hit", (ev:any)=>{
            props.clickHandler(ev.target._dataItem._dataContext.id);
          });

          var columnTemplate = series.columns.template;
          columnTemplate.strokeWidth = 2;
          columnTemplate.strokeOpacity = 1;
          columnTemplate.fill = seriesColor;
          columnTemplate.stroke = seriesColor;
          columnTemplate.width = am4core.percent(70);

        }
      }
  }

  return (
    <div id={props.id} style={{ width: "100%", height: "100%"}}></div>
  );
}



export default AlarmComboChartGood;

